import React from "react";
import { useNavigate } from "react-router-dom";

export default function InFeedEditorial({ item }) {
  const navigate = useNavigate();
  if (!item) return null;
  const onOpen = () => {
    if (item.link?.startsWith("/")) navigate(item.link);
    else if (item.link) window.open(item.link, "_blank");
  };
  return (
    <div className="lt-infeed" data-testid={`infeed-${item.id}`} onClick={onOpen}>
      <div className="lt-infeed-img" style={{backgroundImage:`url("${item.image_url}")`}}>
        <div className="lt-infeed-overlay">
          <div className="lt-infeed-tag">LANTEN READS</div>
          <div className="lt-infeed-title">{item.title}</div>
          {item.subtitle && <div className="lt-infeed-sub">{item.subtitle}</div>}
          <div className="lt-infeed-arrow">Read the guide →</div>
        </div>
      </div>
    </div>
  );
}
